import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { findScopeVariableMatches } from 'components/powerFlowShared/helpers/findScopeVariableMatches';
import { flowNodeColor } from 'fable/flowEditor';
import { Text } from 'flow-builder/node/text';
import { TextBreak } from 'flow-builder/node/textBreak';
import { TextContent } from 'flow-builder/node/textContent';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import { parseHtmlStringToDom } from '../../shared/utils/domParser';
import { MessageModal as MessengerMessageModal } from '../components/messageModal';
const translateScopeVariables = (node) => {
    const { payload } = node;
    const needs = findScopeVariableMatches(payload.text);
    return {
        grants: [],
        needs,
    };
};
const translatePayload = (node) => {
    const { nextNodeId } = node.payload;
    return [
        {
            id: uuid(),
            label: 'arrow',
            connection: nextNodeId || uuid(),
        },
    ];
};
const updateConnection = (node, _connection, connectionId) => {
    const payload = Object.assign(Object.assign({}, node.payload), { nextNodeId: connectionId });
    return Object.assign(Object.assign({}, node), { payload });
};
export const MessengerMessageNodeAttributes = {
    iconName: 'chat-plus',
    label: 'Message',
    color: hexStringToNumber(flowNodeColor.blue),
    translateScopeVariables,
    translatePayload,
    updateConnection,
    NodeContent: MessengerMessageNode,
    ActionModal: MessengerMessageModal,
};
export function MessengerMessageNode({ node, }) {
    const { payload } = node;
    const { text } = payload;
    return (_jsx(TextContent, Object.assign({ maxLines: 2 }, { children: useMemo(() => {
            var _a, _b, _c;
            const scopeVariables = findScopeVariableMatches(text, [
                'scope',
                'system',
            ]);
            const parsedText = ((_c = (_b = (_a = parseHtmlStringToDom(text)) === null || _a === void 0 ? void 0 : _a.body) === null || _b === void 0 ? void 0 : _b.innerText) !== null && _c !== void 0 ? _c : '').trim();
            const textWithVars = parsedText.split(/{{(?:scope|system):([^}]+)}}/gm);
            return (_jsx(TextBreak, { children: textWithVars.map((text, index) => (_jsx(Text, { weight: scopeVariables.includes(text) ? 'semibold' : 'normal', text: parsedText }, index))) }));
        }, [text]) })));
}
